<nz-radio-group
  class="toggle-tab-container"
  [(ngModel)]="tempModel.type"
  (ngModelChange)="onDisplayTypeChange()"
  [nzSize]="'small'"
  [nzButtonStyle]="'solid'"
>
  <label nz-radio-button nzValue="off">
    Off
  </label>
  <label
    nz-radio-button
    nzValue="row"
    nz-tooltip
    nzOverlayClassName="historical-estimates-tooltip-sm"
    nzTooltipTitle="Show Historical Estimates in rows"
  >
    Rows
  </label>
  <label
    nz-radio-button
    nzValue="column"
    nz-tooltip
    nzOverlayClassName="historical-estimates-tooltip-sm"
    nzTooltipTitle="Show Historical Estimates in columns"
  >
    Columns
  </label>
</nz-radio-group>

<div class="checkbox-sm">
  <label
    class="checkbox-line"
    nz-checkbox
    (ngModelChange)="onPreqChange($event)"
    [ngModel]="tempModel.values.includes('PreQ')"
    >PreQ (prior to earnings)
  </label>
</div>

<div
  class="revision-container"
  *ngFor="let date of datePickerModel; index as i; trackBy: trackByIdx"
>
  <ng-template #effectiveStartTemplate>
    <span>
      <label>Revisions available from:</label>
      <button
        nz-button
        nzType="link"
        (click)="onEffectiveStartClick(i)"
        style="padding: 0px 4px;"
      >
        {{ tempModel.effectiveStart }}
      </button>
    </span>
  </ng-template>

  <div class="revision-date-picker">
    <nz-date-picker
      [nzSize]="'small'"
      [nzPlaceHolder]="'yyyy-mm-dd'"
      [nzDisabledDate]="disabledDate"
      [nzShowToday]="false"
      [(ngModel)]="datePickerModel[i]"
      (ngModelChange)="onDateChange($event, i)"
      [nzRenderExtraFooter]="effectiveStartTemplate"
      [class.date-error]="errorArray[i] !== ''"
    ></nz-date-picker>
    <div
      *ngIf="i !== 0"
      class="btn-remove-revision"
      (click)="removeRevision(i)"
    >
      <va-icon size="small" name="close"></va-icon>
    </div>
  </div>
  <span
    class="checkbox-line"
    *ngIf="tempModel.values[i] !== null && errorArray[i] === ''"
    >Relative date: {{ tempModel.values[i] }}</span
  >
  <span class="checkbox-line error-color">{{ errorArray[i] }}</span>
</div>

<va-icon
  class="btn-add-revision"
  size="small"
  name="plus"
  (click)="addRevision()"
  *ngIf="datePickerModel.length < 5"
></va-icon>

<span class="checkbox-line" *ngIf="datePickerModel.length === 5">
  <span>
    <va-icon name="info-circle" style="color: green;"></va-icon>
  </span>
  Maximum 5 revisions can be set
</span>

<div class="actions">
  <button
    [disabled]="actionsDisabled"
    nz-button
    nzType="default"
    nzSize="small"
    (click)="handleCancel()"
  >
    Cancel
  </button>
  <button
    id="options-refresh-buttons-apply-Revisions"
    [disabled]="actionsDisabled"
    nz-button
    nzType="primary"
    nzSize="small"
    (click)="handleApply($event)"
  >
    Apply
  </button>
</div>
